import React, { Component } from 'react';
import config from 'react-global-configuration';

// Importação do Router
import { Link, Redirect} from 'react-router-dom';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import RequestApi from '../Miscelania/RequestApi';
import ExamUnrelatedAcoes from './Elements/ExamUnrelatedAcoes';

class ExamsIndexUnrelated extends Component {
  desativar_loading () {
    this.setState({status_loading: 0});
  }

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      mensagem_alerta: false,
      tipo_alerta: false,
      status_alerta: false,
      dados: [],
      lista_alunos: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.desativar_loading = this.desativar_loading.bind(this);
    this.provas = this.provas.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.botaoEdicao = this.botaoEdicao.bind(this);
  }

  componentDidMount () {
    this.refs.request_api.verifyPermission();
    this.setState({status_loading: 1});
    this.provas();
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  provas() {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/provas/nao/relacionadas', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        self.setState({status_loading: 2});
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
          self.setState({lista_alunos: responseJson.lista_alunos});
        }
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshTable(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/provas/nao/relacionadas', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        self.setState({status_loading: 2});
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
          self.setState({lista_alunos: responseJson.lista_alunos});
        }
        self.handleAlert(event.message, event.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoEdicao (cell, row) {
    var botao = '';
    botao = <ExamUnrelatedAcoes handleAlert={this.handleAlert} dadosProva={row} refreshTable={this.refreshTable} lista_alunos={this.state.lista_alunos} />
    return botao;
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Lista de provas não relacionadas</h3>
      <Link to="/prova/nao/relacionada" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> Adicionar prova</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há provas cadastrados', defaultSortName: 'id',  defaultSortOrder: 'desc'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>

        <TableHeaderColumn dataField="matter" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Matéria</TableHeaderColumn>

        <TableHeaderColumn dataField="dificuldade" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='150'>Dificuldade</TableHeaderColumn>

        <TableHeaderColumn dataField="created_at_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Gerada em</TableHeaderColumn>

        <TableHeaderColumn dataField="creator" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='200'>Gerada por</TableHeaderColumn>

        <TableHeaderColumn dataField="nota_minima" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Nota mínima</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='150'>Ações</TableHeaderColumn>
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default ExamsIndexUnrelated;



// WEBPACK FOOTER //
// ./src/Components/Exams/ExamsIndexUnrelated.js